import { render, staticRenderFns } from "./centerMemberWorksUpload.vue?vue&type=template&id=1f6dd230&scoped=true&"
import script from "./centerMemberWorksUpload.vue?vue&type=script&lang=js&"
export * from "./centerMemberWorksUpload.vue?vue&type=script&lang=js&"
import style0 from "./centerMemberWorksUpload.vue?vue&type=style&index=0&id=1f6dd230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dd230",
  null
  
)

export default component.exports